module.exports = __webpack_public_path__ + "img/slider-home-2.33435832.png";